import cx from 'classnames';
import { h } from 'preact';

import { DEMOCRAT, NEUTRAL, REPUBLICAN, TIE } from '../colors';

function MapLegend({ candidates, includesNoResult, includesTie }) {
  return (
    <div class="results-map__legend">
      {/* <p class="results-map__legend-title">Leader</p> */}
      <div class="results-map__legend-items">
        {/* {candidates.map(candidate => {
          return (
            <div class="results-map__legend-item">
              <span
                class={cx(
                  'circle-pill',
                  `pill--${candidate.party.slice(0, 3)}`
                )}
              />{' '}
              <p class="results-map__legend-label">
                {candidate.ballot_sort_name}
              </p>
            </div>
          );
        })} */}
        {includesTie && (
          <div class="results-map__legend-item">
            <span class="circle-pill" style={{ backgroundColor: TIE }} />{' '}
            <p class="results-map__legend-label">Tied</p>
          </div>
        )}
        {includesNoResult && (
          <div class="results-map__legend-item">
            <span class="circle-pill" style={{ backgroundColor: NEUTRAL }} />{' '}
            <p class="results-map__legend-label">No votes</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default MapLegend;
